import React from 'react';

const FuseHelpModal = ({
  children,
  classes,
  clickClose,
  clickNext,
  clickPrev,
  currentStep,
  totalSteps,
  style
}) => {
  return (
    <div className={classes} style={style}>
      <button className="close" onClick={clickClose}></button>
      {children}
      <div className="nav-buttons">
        {currentStep > 1 && (
          <button className="prev" onClick={clickPrev}>
            &larr;
          </button>
        )}
        {currentStep < totalSteps && (
          <button className="next" onClick={clickNext}>
            &rarr;
          </button>
        )}
      </div>
    </div>
  );
};

export default FuseHelpModal;
